import firebase from 'firebase'
const firebaseConfig = {
  apiKey: "AIzaSyB-dUePTPHVgOmvcXqshEBREBC1e8q6UmY",
  authDomain: "danapp-b08f3.firebaseapp.com",
  databaseURL: "https://danapp-b08f3.firebaseio.com",
  projectId: "danapp-b08f3",
  storageBucket: "danapp-b08f3.appspot.com",
  messagingSenderId: "862499665916",
  appId: "1:862499665916:web:e2e01c3b323b973f996479"
};
var fire = firebase.initializeApp(firebaseConfig);
export default fire;

const databaseRef = fire.database().ref();
export const whereisdan = databaseRef.child("whereisdan")
export const dancomments = databaseRef.child("dancomments")
